const initScrollingPromotions = () => {
	const promotionsContainer = document.querySelector('.promotions-container')
	if (!promotionsContainer) return

	const items = Array.from(promotionsContainer.querySelectorAll('.promotion'))
	const itemsNumber = parseInt(promotionsContainer.getAttribute('data-items-size')) || 0
	const speed = parseInt(promotionsContainer.getAttribute('data-speed')) || 2
	const disableAnimation = Boolean(promotionsContainer.getAttribute('data-disable-animation'))

	if (disableAnimation) return

	const isResponsive = matchMedia('(max-width: 1098px)').matches
	if (!isResponsive) return

	const cloneCount = itemsNumber === 2 ? 5 : itemsNumber === 3 ? 6 : 1

	for (let i = 0; i < cloneCount; i++) {
		const fragment = document.createDocumentFragment()
		items.forEach((item) => {
			const duplicate = item.cloneNode(true)
			fragment.appendChild(duplicate)
		})
		promotionsContainer.appendChild(fragment)
	}

	let offset = 0

	function animate() {
		offset -= 1 / speed

		if (Math.abs(offset) >= promotionsContainer.scrollWidth / 2) {
			offset = 0
		}

		promotionsContainer.style.transform = `translateX(${offset}px)`
		requestAnimationFrame(animate)
	}

	animate()
}

window.addEventListener('DOMContentLoaded', () => {
	initScrollingPromotions()
})
